































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ImpactoComponent from '../../components/aboutus/Impacto.vue';
import RolSocialComponent from '../../components/aboutus/RolSocial.vue';
import {
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic,
} from "@/configuration";
import api from "@/api";
import { iconsBySlug } from "@/models/Icons";
import PressCard from "@/components/NewPressCard.vue";

@Component({
  metaInfo: {
    title: "RedCapital  | Plataforma de Financiamiento Digital ",
    //titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    },
  },
  data() {
	return{
		press: [],
		medios: [],
		canShow: false
	}
  },
  mounted: 
  	function(){
    if (this.$route.hash) {
      //@ts-ignore
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },
	buildData : async function (){
      try {
		this.$data.canShow = false;
        const { data } = await api.getLastPrensa();
        this.$data.press = data.prensa;

		this.$data.medios = (data.medios || []).map((m: { medio: string; slug: keyof typeof iconsBySlug }) => ({
		  filter: false,
		  medio: m.medio,
		  slug: m.slug,
		  icon: iconsBySlug[m.slug] || ''
		}));

      } catch (error) {
        this.$data.press = [];
        this.$data.tabs = [];

      }
      finally {
        this.$data.canShow = true;
      }
    },
  },
  beforeRouteUpdate (to, from, next) {
    if(to.hash){
      //@ts-ignore
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
    next();
  },
  async beforeMount() {
	//@ts-ignore
   await this.buildData();
  },
  components: {
	ImpactoComponent,
	RolSocialComponent,
	PressCard
  }
})
export default class About extends Vue {}
